import { useState } from 'react';
import CopyIcon from '@/assets/svg/copy-icon.svg';
import { sendMessageToWebView } from '@/utility/webview.ts';
import { PostMessage } from '@/constants/post-message.ts';

interface Props {
	backupRoomInfo:
		| {
				videoCallProvider: string;
				videoCallProviderUrl: string;
		  }
		| undefined;
}

export const MeetLinkCard = ({ backupRoomInfo }: Props) => {
	const [copied, setCopied] = useState(false);

	const onCopyLink = (): void => {
		navigator.clipboard.writeText(backupRoomInfo?.videoCallProviderUrl);

		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 2000);
	};

	const onGoToLink = (): void => {
		if (window?.ReactNativeWebView?.postMessage) {
			sendMessageToWebView({
				type: PostMessage.openExternalLink,
				data: {
					link: backupRoomInfo?.videoCallProviderUrl
				}
			});
		} else {
			window.open(backupRoomInfo?.videoCallProviderUrl, '_blank');
		}
	};

	return (
		<div className="meet-link-card">
			<div className="meet-link-title">Google Meet Toplantı Linki</div>
			<div className="meet-link-desc">Bu toplantı bağlantısını görüşmek istediğiniz öğrencinizle paylaşın</div>
			<div className="meet-link-input">
				<div
					className="meet-link-pointer"
					onClick={() => onGoToLink()}>
					{backupRoomInfo?.videoCallProviderUrl}
				</div>

				<div
					className="copy-txt"
					onClick={() => onCopyLink()}>
					<img src={CopyIcon} />

					<div className="tooltip-box">{copied ? 'Bağlantı kopyalandı' : 'Bağlantıyı kopyala'}</div>
				</div>
			</div>
		</div>
	);
};
